module.exports = {"data":{"markdownRemark":{"html":"<p>An article I wrote :)</p>\n<p><a href=\"/how-should-i-test-my-react-components\">How should I test my React components?</a></p>","frontmatter":{"title":"My work","date":null}}},"pathContext":{"slug":"/my-work","prev":{"fields":{"slug":"/sydney-new-zealand-journal"},"frontmatter":{"title":"Sydney & New Zealand journal"}},"next":{"fields":{"slug":"/weird-about-us"},"frontmatter":{"title":"Weird about US"}}}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/my-work.json
// module id = 400
// module chunks = 233427756548064